import { FlexBox, List } from '@dixa/lib-shared-habla';
import { MessageAttachedFile } from 'lib-shared-legacy-types';
import React from 'react';

import {
  FieldSubmission,
  FileFieldValue,
} from 'app/views/layout/views/settings/views/customForms';

import styles from './CustomFormSubmissionRow.module.scss';
import { createAttachedFiles } from './utils/AttachedFile';

type Props = {
  label: string;
  fieldSubmission?: FieldSubmission;
};

export const CustomFormSubmissionRow = ({
  label,
  fieldSubmission,
}: Props): JSX.Element => {
  if (!fieldSubmission) {
    return (
      <List.KeyValue
        className={styles.keyValue}
        withHoverEffect={false}
        pair={{ key: label, value: '' }}
      />
    );
  }

  return (
    <List.KeyValue
      className={styles.keyValue}
      withHoverEffect={false}
      pair={{ key: label, value: renderFieldSubmission(fieldSubmission) }}
    />
  );
};

function renderFieldSubmission({
  type,
  value,
}: FieldSubmission): React.ReactNode {
  switch (type) {
    case 'string':
      return value;
    case 'stringArray':
      return value.join(', ');
    case 'fileArray':
      const attachedFilesElement = createAttachedFiles(
        (value as FileFieldValue[]).map(
          ({ name, relative_url }): MessageAttachedFile => ({
            url: relative_url,
            pretty_name: name,
          }),
        ),
      );

      return <FlexBox flexDirection="column">{attachedFilesElement}</FlexBox>;
  }
}
